const REDUCER_NAME = 'columnsMap';
const ACTION_TYPES = {
  FETCH_COLUMNS_MAP: `${REDUCER_NAME}/FETCH_COLUMNS_MAP`,
  SET_COLUMNS_MAP: `${REDUCER_NAME}/SET_COLUMNS_MAP`,
};

export default ACTION_TYPES;
